// тестовые айдишники, чтобы было проще тестировать
export const INFORMATION_ABOUT_FLIGHT_TYPES_DATA_TEST_ID =
  'lt-information-about-flight-types-data-test-id';
export const INFORMATION_ABOUT_FLIGHT_TYPES_CLOSE_BUTTON_DATA_TEST_ID =
  'lt-information-about-flight-types-close-button-data-test-id';

// кука для управления баннером
export const KEY_COOKIE = 'lt_banner_information_about_flights_type';

// для аналитики
export const DATA_LAYER_CLOSE_BANNER =
  'lt_close_banner_information_about_flight_types';
